import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ClockCounterIcon } from '@moia-dev/pace-icons'
import { FleetTracingAreaRoutes } from './FleetTracingAreaRoutes'

export const FleetTracingAreaNavigationIcon = ClockCounterIcon

export const FleetTracingAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FleetTracingAreaRoutes.route}
      Icon={ClockCounterIcon}
    />
  )
}
